import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import media from '../../utils/media';
import { COLOR_MAPPING_INFOGRAPHIC } from '../../constants';
const Container = styled.section `
  outline: none;
  width: 85%;
  max-width: 1110px;
  min-height: 670px;
  margin: 0 auto;
  margin-bottom: 93px;

  ${media.mobile} {
    margin-bottom: 36px;
  }

  ${media.mobileL} {
    width: calc(100% - 20px);
    margin: 0 10px 40px;
    height: auto;
    min-height: auto;
  }
`;
const HeaderContainer = styled.div `
  display: block;
  width: 100%;
`;
const ContentContainer = styled.div `
  display: flex;
  width: 100%;
  justify-content: flex-start;

  ${media.tablet} {
    flex-direction: column;
    padding: 0;
    align-items: center;
  }
`;
const Content = styled.div `
  flex: 1;
  width: 50%;
  max-width: 540px;
  ${media.tablet} {
    padding: 0;
    width: 100%;
  }
`;
const ContentDivider = styled.div `
  width: 30px;

  ${media.tablet} {
    width: 100%;
    height: 40px;
  }
`;
export const GraphSection = styled.div `
  display: block;
  width: 100%;
  height: fit-content;
  min-width: 30px;
  min-height: 100px;
  ${media.smallTablet} {
    flex-direction: column;
    padding: 0;
    align-items: center;
  }

  .graphic-container:nth-of-type(1) .item-container.speedometer {
    padding: 10px 0px 30px 60px;

    ${media.tablet} {
      padding: 10px 0px 30px 30px;
    }

    ${media.mobile} {
      padding: 30px 0px 30px 0px;
    }
  }

  .graphic-container:nth-of-type(2) .chart-indicator {
    stroke: ${COLOR_MAPPING_INFOGRAPHIC[1]};
  }

  .graphic-container:nth-of-type(3) .chart-indicator {
    stroke: ${COLOR_MAPPING_INFOGRAPHIC[2]};
  }

  // styling for bar charts
  .bar-chart-container:nth-of-type(2) .chart-indicator {
    background-color: ${COLOR_MAPPING_INFOGRAPHIC[1]};
  }
  .bar-chart-container:nth-of-type(2) h4 {
    color: ${COLOR_MAPPING_INFOGRAPHIC[1]};
  }
  .bar-chart-container:nth-of-type(3) .chart-indicator {
    background-color: ${COLOR_MAPPING_INFOGRAPHIC[2]};
  }
  .bar-chart-container:nth-of-type(3) h4 {
    color: ${COLOR_MAPPING_INFOGRAPHIC[2]};
  }
  .bar-chart-container:nth-of-type(4) .chart-indicator {
    background-color: ${COLOR_MAPPING_INFOGRAPHIC[3]};
  }
  .bar-chart-container:nth-of-type(4) h4 {
    color: ${COLOR_MAPPING_INFOGRAPHIC[3]};
  }
  .bar-chart-container:nth-of-type(5) .chart-indicator {
    background-color: ${COLOR_MAPPING_INFOGRAPHIC[4]};
  }
  .bar-chart-container:nth-of-type(5) h4 {
    color: ${COLOR_MAPPING_INFOGRAPHIC[4]};
  }
`;
export const GraphSectionWithOneChild = styled.div `
  .graphic-container {
    display: flex;
    justify-content: center;
    .item-container {
      flex: 1;
      max-width: 270px;
      padding: 0px 0px 30px 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: inherit;
    }

    .text-container {
      text-align: center;
      margin: 0px;

      h4 {
        margin-bottom: 19px;
      }
    }

    .speedometer-container {
      margin: 0px 0px 30px 0px;

      .chart-value {
        font-size: 55px;
        width: 61.72px;
        height: 41.14px;

        ${media.mobile} {
          font-size: 40px;
          width: 45px;
          height: 30px;
        }
      }
      .chart-symbol {
        width: 23.62px;
        height: 24.69px;
        font-size: 27px;
        line-height: 25px;
        transform: translateY(-35%);
        ${media.mobile} {
          width: 17px;
          height: 18px;
          font-size: 20px;
          line-height: 25px;
          transform: translateY(-25%);
        }
      }
    }
  }

  .number-value-container {
    border-bottom: 4px solid ${({ theme }) => theme.greyLightMedium};
    margin-bottom: 34px;
    position: relative;
    padding-bottom: 10px;

    span {
      font-family: ${({ theme }) => theme.fontFamilyBold};
      height: 86.95px;
      font-size: 70px;
      line-height: 70px;
      width: 100%;
      transform: translateY(10px);

      ${media.mobile} {
        font-size: 48.62px;
        line-height: 49px;
        height: 59.05px;
      }
    }
  }

  .number-value-container::after {
    content: '';
    position: absolute;
    left: 50%;
    top: calc(100% + 4px);
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${({ theme }) => theme.greyLightMedium};
    clear: both;
  }

  .static-number {
    .item-container {
      border-bottom: none;

      ${media.mobileL} {
        padding: 0px 0px 10px 0px;
      }
    }

    .static-number-container {
      justify-content: center;
    }
    .text-container {
      max-width: 480px;
      ${media.mobile} {
        max-width: 280px;
      }
    }
  }
`;
const SourceSection = styled.div `
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: space-around;
`;
export const InfoGraphicContainer = ({ rendering }) => {
    if (!rendering) {
        return null;
    }
    const { ariaLabel } = rendering.fields;
    const graphSectionRendersOneChild = rendering.placeholders['infographics-graph-section'].length === 1;
    const graphSectionTheme = {
        graphSectionRendersOneChild,
        speedometerSingleDesktopItem: {
            dimensions: 200,
            strokeWidth: 25,
            fontSize: 55,
        },
    };
    return (React.createElement(Container, { "aria-label": ariaLabel && ariaLabel.value },
        React.createElement(HeaderContainer, null,
            React.createElement(Placeholder, { name: "infographics-header", rendering: rendering })),
        React.createElement(ContentContainer, null,
            React.createElement(Content, null,
                React.createElement(Placeholder, { name: "infographics-text", rendering: rendering })),
            React.createElement(ContentDivider, null),
            React.createElement(Content, null,
                React.createElement(ThemeProvider, { theme: graphSectionTheme }, graphSectionRendersOneChild ? (React.createElement(GraphSectionWithOneChild, null,
                    React.createElement(Placeholder, { name: "infographics-graph-section", rendering: rendering }))) : (React.createElement(GraphSection, null,
                    React.createElement(Placeholder, { name: "infographics-graph-section", rendering: rendering })))),
                React.createElement(SourceSection, null,
                    React.createElement(Placeholder, { name: "infographics-source-section", rendering: rendering }))))));
};
